import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Facebook from "./images/TE.png"
import Instagram from "./images/INSE.png"
import Twitter from "./images/TWE.png"


import styled from 'styled-components';

import backgroundPic from "./images/headphones.jpg";

import Footer from "./Footer"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color:"#fff",
    width:600,
    alignContent:"center",
    alignItems:"center",

  },
  title: {
    flexGrow: 1,
    textAlign: 'start',
    color:"#FFF"
  },
  appBar:{
    background:"transparent",
    elevation:0
  },
  myTabs:{
    textAlign:"end",
    padding:20
  },
  tabButns:{
    border:"transparent",
    color:"#FFF"
  },
  headerBackground:{
    background: `url(${backgroundPic}) no-repeat`,
    backgroundSize: "cover",

  },
  textOnSlideShow:{
    textAlign:"center",
    width:"80%",
    color:"#FFF",
    alignContent:"center",
    alignItems:"center",
    
  },
 
}));


const StyledButton = styled.button`
color: white;
	padding: 5px;
	border: 1px;
	background: none;
  font-size: 1em;
  margin: 5px 10px 0px;

	&:hover {
		background: none;
    color: purple;
    cursor:pointer;
	}
`;

function Contacts() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} className={classes.headerBackground}>
        <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            K-BRIELLY MUSIC
          </Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.myTabs}>
        <StyledButton
        onClick={()=>{
          window.location.href="/"
        }}
          onMouseEnter={()=>{
            console.log("color")
          }}>
          HOME
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/stream"
        }}
        >
          STREAM
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/music"
        }}
        >
          MUSIC
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/videos"
        }}
        >
          VIDEOS
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/contacts"
        }}
        >
          CONTACT
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/about"
        }}
        >
          ABOUT
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/"
        }}
        >
          BLOG
        </StyledButton>
      </div>
      <hr></hr>
        </Grid>
        <Grid container justify="center"  style={{background:"black",color:"#fff"}}>
          <Grid item  className={classes.paper}>
            <h1>Contact Us</h1>
            <h4>Facebook</h4>
            I've got an official Facebook page where I share most of my daily updates, information, news and future endeavors of my brand. This is the same platform where I turn to interact more with my fans and share music with them.
            I always encourage my fans, followers or any business dealers interested in my brand and music to follow this page so that they can enquire about my services, get more exposure to information about my products and for faster customer care support.
            <h4>Instagram </h4>
            If you are enticed by K-Brielly's graphics and video content you should definitely follow my Instagram page. I share pictures, video content and interact with my fans and follower so that they can appreciate my products and services. 
            <h4  >Twitter </h4>
            I'm also available on twitter for sure. Even though i use my twitter account specifically for my music, there is always a chance that you can get hold of me throught it. So basically I share my music links and insights on my products with the world
            on this platform. I really much appreciate feedback from all corners of the world and would really much appreciate having you in my little community of follower, so smash that twitter icon and follow  me. 
          </Grid>
              <Grid item xs={12} className={classes.paper}>
                <div className={classes.media}>
                  <h4>Connect with us on social media</h4>
                    <a style={{marginRight:10}} href="https://facebook.com/kbrielly">
                      <img alt="Facebook logo" src={Facebook} height={30}  />
                    </a>
                    <a style={{marginRight:10}} href="https://instagram.com/_kbrielly">
                      <img alt="Instagram logo" src={Instagram} height={30}  />
                    </a>
                    <a style={{marginRight:10}} href="https://twitter.com/_kbrielly">
                      <img alt="Twitter logo" src={Twitter} height={30}  />
                    </a>
                </div>
                <div className={classes.contact}>
                    <h4>Contact Us on</h4>
                    <ul style={{listStyle:"none",color:"#FFF"}}>
                      <li>Cell number 1: (+267) 74 369 947</li>
                      <li>Cell number 2: (+267) 73 319 835</li>
                      <li ><span style={{textTransform:"lowercase",fontSize:16}}>kbriellymokgadi@gmail.com</span></li>
                    </ul>
                </div>
              </Grid>
          </Grid>    
        <Grid item xs={12} >
          <Footer/>
        </Grid>
        </Grid>
      
    </div> 
  );
}

export default Contacts;
